import { render, staticRenderFns } from "./brushes.vue?vue&type=template&id=75c91cd0&"
import script from "./brushes.vue?vue&type=script&lang=js&"
export * from "./brushes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports